var cookies = require('js-cookie')

module.exports = function () {
  var clientCookie = cookies.get('csasauxid')
  return !!clientCookie
}
